import { NgModule } from '@angular/core';

import { CoreModule } from '../core/core.module';

import {RegistrationComponent, RegistrationInfoDialogComponent} from './registration.component';

import { RegistrationService } from '../core/services/registration.service';

import { RegistrationRoutingModule } from './registration-routing.module';

import { MobileSuccessDialogComponent } from './mobile-success-dialog/mobile-success-dialog.component';

@NgModule({
    declarations: [
        RegistrationComponent, 
        RegistrationInfoDialogComponent, 
        MobileSuccessDialogComponent
    ],
    imports: [
        CoreModule,
        RegistrationRoutingModule,
    ],
    providers: [RegistrationService]
})

export class RegistrationModule {}
